import React from "react";
import { useAuth } from "../auth/AuthContext";
import Dashboard from "../components/Dashboard";

/**
 * The authenticated app at /dashboard.
 *
 * Always the Dashboard — teamless users get it too, with the join/create
 * actions where the PR list normally sits.
 *
 * This used to branch between the Dashboard and the onboarding wizard based on
 * `teamlessView`, a localStorage preference. The wizard has its own route now
 * (/onboarding), so there is no "which screen?" question left to answer and
 * nothing to keep in sync. That branch had four ways of producing the wrong
 * screen: never set, cleared by logout, disagreeing with /team and /analytics
 * (which never consulted it), and overridden by a stale join code. See gotcha
 * #54 — the mechanism was the defect, not any one of its symptoms.
 */
export default function AppHome() {
  const { user, logout } = useAuth();
  return <Dashboard user={user} onLogout={logout} />;
}
